<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Manpower"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        工时制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-actve" id="active-Id-BOX">云办公APP申请流程</h4>
                    <span class="spanClass actve" id="firstIdactive">第一步：下载云办公APP，输入账号（姓名全拼写+数字）和密码（与邮箱密码一致）登陆。</span>
                    <span class="spanClass" id="firstIdactive">第二步：打开云办公，点击【HR自助】-【假勤申请】-右下角【+】。</span>
                    <span class="spanClass" id="firstIdactive">第三步：点击相应类别（以“特殊情况说明”为例），点击【特殊情况说明】-【时间段】，在出现的本月打卡记录中，选择异常的打卡记录（可任意选中一天或多天），点击【确定】。</span>
                    <span class="spanClass" id="firstIdactive">第四步：如图所示，选择未打卡的时间段，填写【详细描述】和【申请原因】，确认无误后点击【提交】-【确认】。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-actve" id="active-Id-BOX">云办公APP申请流程</h4>
                    <span class="spanClass" id="firstIdactive">第五步：待所有假勤申请通过审批后，点击【HR自助】-【考勤确认】-【确认本月考勤】-【确定】。</span>
                    <img src="../../assets/13.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {

        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
        fn() {

        }
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical", // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}

.contentImg {
    width: 100%;
    display: block;
    margin-top: 15px;
}
#active-Id-BOX {
    margin-bottom: 20px;
    font-size: 16px
}
#firstIdactive {
    text-indent: 0px !important;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Manpower/manpowerParticulars7.vue